import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const RADIOLOGY_PATH = "/radiology/v1";

// Pathology

export const getRadiologyApi = async (params) =>
  await getRequest(`${RADIOLOGY_PATH}/list`, params);

export const getRadiologyByIdApi = async (params) =>
  await getRequest(`${RADIOLOGY_PATH}/request/${params?.id}`);

export const updateRadiologyApi = async (id, body) =>
  await putRequest(`${RADIOLOGY_PATH}/request/${id}`, body);

export const printRadiologyApi = async (id) =>
  await getRequest(`${RADIOLOGY_PATH}/report/${id}/pdf`, {}, true);

export const deleteRadiologyByIdApi = async (id) =>
  await deleteRequest(`${RADIOLOGY_PATH}/request/${id}`);
